module.exports = __webpack_public_path__ + "img/gasAlarm.0c6540e4.png";